import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { ApiKeyItemInfo } from "@/pages/integrations/api/integrations-api-page.types";
import {
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
  MDSModalDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSButtonGroup,
} from "@/mds";

type TProps = {
  keyToDelete: ApiKeyItemInfo | null;
  setKeyToDelete: (keyToDelete: ApiKeyItemInfo | null) => void;
};

export const DeleteKeyModal = observer(({ keyToDelete, setKeyToDelete }: TProps) => {
  const { store } = useAppStore();

  const isModalOpen = !!keyToDelete;
  const { id: keyId, title: keyTitle } = keyToDelete ?? {};

  const handleCloseModal = () => {
    setKeyToDelete(null);
  };

  const handleDeleteApiKey = () => {
    setKeyToDelete(null);

    if (!keyId) {
      return;
    }

    store.apiKeys.deleteApiKey({ id: keyId });
  };

  return (
    <MDSModalDialog isOpen={isModalOpen} handleClose={handleCloseModal}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {keyTitle
          ? `Are you sure you want to delete “${keyTitle}”?`
          : "Are you sure you want to delete this API key?"}
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          Deletion is permanent and cannot be undone.
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={handleCloseModal}>Cancel</MDSButton>
        <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={handleDeleteApiKey}>
          Delete forever
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
